import { Action, State } from './types';

export default function reducer(state: State, action: Action): State {
  switch (action.type) {
    case 'hide': {
      if (state.length === 0) {
        return state;
      }

      const [first, ...rest] = state;
      return [
        {
          ...first,
          show: false,
        },
        ...rest,
      ];
    }

    case 'push': {
      const { payload: modal } = action;
      const { name } = modal;
      if (
        !state.some((stateModal) => stateModal.name === name && stateModal.show)
      ) {
        return [...state, { ...modal, show: true }];
      }
      return state;
    }

    case 'pop': {
      const [, ...rest] = state;
      return rest;
    }

    default:
      return state;
  }
}
